import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import {numify} from 'numify'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  showCount?: number
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  showCount = 0,
}) => {
    const {pathname} = useLocation()
    const isActive = checkIsActive(pathname, to)
    const {config} = useLayout()
    const {app} = config

    return (
    <div className='menu-item'>
        <Link className={clsx('menu-link without-sub', {active: isActive})} to={to}>
            {hasBullet && (
            <span className='menu-bullet me-1'>
                <span className='bullet bullet-dot'></span>
            </span>
            )}
            {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
            <span className='menu-icon me-1'>
                {' '}
                <KTSVG path={icon} className='svg-icon-2' />
            </span>
            )}
            {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
            <i className={clsx('bi fs-3', fontIcon)}></i>
            )}
            <span className='menu-title'>{title}</span>
            {(showCount > 0) && 
            <div className="badge badge-pill badge-info px-1 min-w-20px justify-content-center">{numify(showCount)}</div>
            }
        </Link>
            {children}
    </div>
    )
}

export {SidebarMenuItem}
